export const lifeCycleEntitiesMap = {
  stage: 'stage',
  step: 'step',
  acceptanceStatus: 'acceptanceStatus',
};

export const addressIdFieldName = 'addressId';

export const selectFieldNames = {
  [lifeCycleEntitiesMap.stage]: 'stageAddressLifeCycleId',
  [lifeCycleEntitiesMap.step]: 'stepAddressLifeCycleId',
};
